import { useShouldShowPrompt } from "./pwaHandler";

// standalone only exists on IOS safari per https://developer.mozilla.org/en-US/docs/Web/API/Navigator
interface NavigatorIOS extends Navigator {
  standalone: boolean;
}

const isIOS = (): boolean => {
  if ((navigator as NavigatorIOS).standalone) {
    //user has already installed the app
    return false;
  }
  const ua = window.navigator.userAgent;
  const isIPad = !!ua.match(/iPad/i);
  const isIPhone = !!ua.match(/iPhone/i);
  return isIPad || isIPhone;
};

export const useIosInstallPrompt = (): [boolean, () => void] => {
  const [userShouldBePromptedToInstall, handleUserSeeingInstallPrompt] =
    useShouldShowPrompt();

  return [
    isIOS() && userShouldBePromptedToInstall,
    handleUserSeeingInstallPrompt,
  ];
};
